import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/lib/injection.tokens';
import { AbstractTagProviderComponent } from '../abstract-tag-provider.component';

@Component({
  selector: 'app-payu-tag-component',
  templateUrl: './payu.component.html',
  styleUrls: ['./payu.component.scss']
})
export class PayuComponent extends AbstractTagProviderComponent implements OnInit {
  constructor(
    protected renderer: Renderer2,
    @Inject(DOCUMENT) protected _document: any,
    @Inject(ENVIRONMENT_TOKEN) protected environment: any
  ) {
    super(renderer, _document);
  }

  public ngOnInit(): void {
    this.addElement(this.getPayUSdkScriptElement(), this._document.head);
  }

  protected getPayUSdkScriptElement(): HTMLElement {
    return this.createScriptExternalElement(`${this.getPayUBaseUrl()}/javascript/sdk`, {});
  }

  protected getPayUBaseUrl(): string {
    return this.environment?.production ? 'https://secure.payu.com' : 'https://secure.snd.payu.com';
  }
}
